<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :default-sort="defaultSort" :col-span="colSpan" :label-width="'100px'" :search-btn-span="colSpan" :get-action="queryApi" :serial="false" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu" @sort-change="sortChange">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.profileTemplateName')" prop="keywords">
            <BjSelectLov v-model="queryParams.keywords" :option-list="TEMPLETE_LIST" :placeholder="$t('chooseText')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.companySeller')" prop="companyName">
            <BjSelectLov v-model="queryParams.companyName" :option-list="clientCodeList" :placeholder="$t('chooseText')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('RoleManagement.common.Status')" prop="state">
            <BjSelectLov v-model="queryParams.state" :clearable="false" :option-list="BILLING_CATEGORI_STATUS" :placeholder="$t('chooseText')" @change="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs :value="tabValue2" :option-list="TAB_LIST2" @handleTabClick="tabClick" />
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="createNew">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <!-- :sortable="['bjTableAction', 'effectiveDate', 'startDate'].includes(col.prop)"  -->
          <el-table-column v-if="!['bjTableAction', 'effectiveDate', 'startDate'].includes(col.prop)" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false"  align="center" class-name="item">
            <template slot-scope="scope">
              <el-tag v-if="col.prop === 'state'" :type="scope.row.state == 'Running' ? 'success' : 'info'">
                {{ $t(BILLING_CATEGORI_STATUS.bjGet(scope.row.state)) }}
              </el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <vxe-table-column v-else-if="col.prop === 'effectiveDate'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="effective_date" :title="col.label" sortable width="135px">
            <template slot-scope="scope">{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'startDate'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="start_date" :title="col.label" sortable width="135px">
            <template slot-scope="scope">{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
          </vxe-table-column>

          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onEdit(props.row, true)">{{ $t('viewText') }}</el-button>
                <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                  <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-permission:BillingClientProfilesAuditIsPass command="1" v-if="tabValue2 == 2">{{ $t('auditPassText')}}</el-dropdown-item>
                    <el-dropdown-item v-permission:BillingClientProfilesAuditIsPass command="2" v-if="tabValue2 == 2">{{ $t('auditNotPassText')}}</el-dropdown-item>
                    <el-dropdown-item command="5" v-if="tabValue2 == 1">{{ $t('billingPage.run') }}</el-dropdown-item>
                    <el-dropdown-item command="6" v-if="tabValue2 == 1">{{ $t('billingPage.stop') }}</el-dropdown-item>
                    <el-dropdown-item command="3">{{ $t('editText') }} </el-dropdown-item>
                    <el-dropdown-item command="4"> {{ $t('delText') }} </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <drawerData ref="drawerData" @handleConfirm="handleConfirm" :clientCodeList="clientCodeList"/>
    
    <viewChargeDialog ref="chargeDialogRef" @reject="onReject"/>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import drawerData from './components/drawerData';
import { billApi } from '@/api';
import { BILLING_CATEGORI_STATUS } from '@/utils/constants';
import viewChargeDialog from '../additionalCharge/components/viewChargeDialog';

export default {
  name: 'ProfileTemplates',
  components: {
    drawerData, viewChargeDialog
  },
  mixins: [pageMiXin],
  data() {
    return {
      BILLING_CATEGORI_STATUS,
      colSpan: 8,
      queryParams: {
        keywords: '',
        companyName: '',
        state: null,
        sortedFields: ''
      },
      queryApi: billApi.getProfileClientList,
      tabValue2: '1',
      TAB_LIST2: [
        { label: this.$t('ApprovedText2'), value: '1' },
        { label: this.$t('ApprovedPending'), value: '2' },
        { label: this.$t('ApprovedRejected'), value: '3' },
      ],
      labelList1: [
        { label: this.$t('billingPage.index'), prop: 'id', isCheck: true, disabled: false, width: 80 },
        { label: this.$t('billingPage.profileTemplateName'), prop: 'billProfileTemplateName', isCheck: true, disabled: false },
        { label: this.$t('billingPage.companyName'), prop: 'companyName', isCheck: true, disabled: false },
        { label: this.$t('billingPage.CurrentTier'), prop: 'currentTier', isCheck: true, disabled: false },
        { label: this.$t('billingPage.EvaluatedTier'), prop: 'evaluatedTier', isCheck: true, disabled: false },
        
        { label: this.$t('billingPage.clientCode'), prop: 'clientCode', isCheck: true, disabled: false, width: 137 },
        { label: this.$t('BjDialogListConfig.Operator'), prop: 'updatedBy', isCheck: true, disabled: false },
        { label: this.$t('billingPage.effectiveDate'), prop: 'effectiveDate', isCheck: true, disabled: false },
        { label: this.$t('form.startDateText'), prop: 'startDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Status'), prop: 'state', isCheck: true, disabled: false },
        { label: this.$t('billingPage.description'), prop: 'description', isCheck: true, disabled: false },
        { label: this.$t('ApprovalDescription'), prop: 'auditDescription', isCheck: true, disabled: false },
        { label: this.$t('fileSearch.page.Download'), prop: 'bjTableAction', isCheck: true, disabled: false, width:140 },
      ],
      // 下拉搜索列表
      clientCodeList: [],
      TEMPLETE_LIST: [],
      defaultSort: [],
    };
  },
  computed: {
    labelList() {
      return this.tabValue2 == 3 ? this.labelList1 : this.labelList1.filter(item => item.prop != 'auditDescription')
    }
  },
  created() {
    this.getProfileTemplateList()
    this.getClientInfoList();
  },
  methods: {
    sortChange (column) {
      if(column.order){
        this.defaultSort = [{ field: column.field, order: column.order }];
        this.queryParams.sortedFields = `${column.field} ${String(column.order).toUpperCase()}`;
      }else{
        this.defaultSort = [];
        this.queryParams.sortedFields = ''
      }
      this.reFresh()
    },
    command(text, row) {
      switch (text) {
        case '1':
            this.onApprove(row)
            break;
        case '2':
            this.$refs.chargeDialogRef.dialogVisible2 = true;
            this.$refs.chargeDialogRef.form.transNo = row.id
            break;
        case '3':
            this.onEdit(row)
            break;
        case '4':
            this.onDelete(row)
            break;
        case '5':
            this.goUp(row)
            break;
        case '6':
            this.goDown(row)
            break;
      }
    },
    onApprove(item){
      billApi.approveProfileClient({id: item.id}).then(()=>{
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      })
    },
    onReject(item){
      const { transNo, description } = item
      billApi.rejectProfileClient({ id: transNo, description }).then(()=>{
        this.$refs.chargeDialogRef.close()
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      })
    },
    tabClick(tab) {
      if(tab.name == 1){
        this.queryApi = billApi.getProfileClientList
      }else if(tab.name == 2){
        this.queryApi = billApi.pendingProfileClient
      }else{
        this.queryApi = billApi.rejectedProfileClient
      }
      this.tabValue2 = tab.name
      setTimeout(() => { this.reFresh(); }, 300);
    },
    // 获取所有客户信息列表
    getProfileTemplateList(){
      billApi.getProfileTemplateList({size:99}).then(res=>{
        this.TEMPLETE_LIST = res.data.content.map(item => {
            return { label: item.profileTemplate.name, value: item.profileTemplate.name}
        });
      })
    },
    getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
    },
    // 启用
    goUp(item) {
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(()=>{
        billApi.runProfileClient({id: item.id}).then(() => {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
      })
    },
    // 停用
    goDown(item) {
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(()=>{
        billApi.stopProfileClient({id: item.id}).then(() => {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
      })
    },
    handleConfirm(row) {
      const { categoryCodes, id, clientCode, effectiveDate, billProfileTemplateId, description, currentTierId } = row;
      const obj = { categoryCodes, id, clientCode, effectiveDate, billProfileTemplateId, description, currentTierId };
      if (row.id) {
        billApi.updateProfileClient(obj).then((res) => {
          if (res.code == 200) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      } else {
        billApi.addProfileClient(obj).then((res) => {
          if (res.code == 200) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      }
    },
    onEdit(item, bstop = false) {
        this.$refs.drawerData.formDisable = bstop;
        this.$refs.drawerData.drawer = true;
        this.$refs.drawerData.form = {
          ...item,
          categoryCodes: item.profileClientPrices,
          currentTierId: item.clientTierId || null,
          // evaluatedTier: [new Date(item.gmtCreate), new Date(item.gmtUpdate)]
        };
    },
    onDelete(item) {
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(()=>{
        billApi.deleteProfileClient({id: item.id}).then((res) => {
          if (res.code == 200) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      })
    },
    createNew() {
        this.$refs.drawerData.drawer = true;
        this.$refs.drawerData.form = {
          clientCode: '',
          effectiveDate: '',
          description: '',
          billProfileTemplateId: null,
          categoryCodes: [],
        };
    }
  },
};
</script>
